<template>
	<StyleCollapseControl
		:property="getProperty(PROPERTY_BACKGROUND_COLOR_NULL, state)"
		:element="element"
		collapse-title="background"
	>
		<div class="form-group">
			<div class="form-group__item form-grid">
				<StyleColorControl
					:element="element"
					:property="getProperty(PROPERTY_BACKGROUND_COLOR, state)"
					label="Color"
				/>
			</div>
		</div>
	</StyleCollapseControl>
</template>

<script>
import StyleCollapseControl
	from '@/components/builder-drawers/drawers/partials/globalStylesDrawer/controls/StyleCollapseControl.vue';
import StyleColorControl from '@/components/builder-drawers/drawers/partials/globalStylesDrawer/controls/StyleColorControl.vue';
import { getProperty }
	from '@/components/builder-drawers/drawers/partials/globalStylesDrawer/controls/utils/getProperty';
import {
	PROPERTY_BACKGROUND_COLOR,
	PROPERTY_BACKGROUND_COLOR_NULL,
} from '@/constants/globalStyles';

export default {
	components: {
		StyleCollapseControl,
		StyleColorControl,
	},
	props: {
		element: {
			type: String,
			required: true,
		},
		state: {
			type: String,
			default: null,
			validator(value) {
				return ['hover'].includes(value);
			},
		},
	},
	setup() {
		return {
			PROPERTY_BACKGROUND_COLOR,
			PROPERTY_BACKGROUND_COLOR_NULL,
			getProperty,
		};
	},
};
</script>

<style scoped lang="scss">
@import '@/components/builder-drawers/drawers/partials/_forms.scss';
</style>
